<template>
    <v-list one-line multiple class='overflow-y-auto' style='max-height:77.3vh;'>
        <template v-for='(group) in $store.getters.msgGroups'>
        <v-list-item
            :key="group.msg_group_id"
            @click="activeGroup = group; debug(group);"
            v-bind:style="hasUnreadMessages(group) ? 'font-weight: bold;' : 'border: none;'"
        >
            <v-list-item-avatar>
            <v-icon large v-if="numOfMembers(group) < 3">mdi-account-circle</v-icon>
            <v-icon large v-if="numOfMembers(group) >=3 ">mdi-account-group</v-icon>
            </v-list-item-avatar>

            <v-list-item-content style='text-align: left;'>
            <v-list-item-title v-html="group.name"></v-list-item-title>
            <v-list-item-subtitle v-if="isText(group.last_message)" v-html="group.last_message"></v-list-item-subtitle>
            <v-list-item-subtitle v-if="!isText(group.last_message)">(image)</v-list-item-subtitle>
            </v-list-item-content><span v-if='group.unread_messages>0'>🔴</span>
        </v-list-item>
        </template>

    </v-list>

</template>

<script >
import Vue from 'vue';
import { mapState } from 'vuex';
import Common from '../mixins/common.vue';


export default Vue.extend({
  mixins: [Common],
  data() {
    return {
      viewMsgGroupId: null,
      viewMsgGroupName: null,
      loading: true,
    };
  },
  computed: {
    activeGroup: {
      get() {
        return this.$store.state.activeMsgGroup;
      },
      set(newval) {
        this.$store.commit('activeMsgGroup', newval);
      }
    },
    
    local_uid() { return this.user.user_id },
  },
  components: {
  },
  methods: {
    debug: function(e) {
      console.log('debug: ', e)
    },
    hasUnreadMessages: function(group) {
       return group.unread_messages>0;
    },
    numOfMembers: function(group) {
        return group.memberCount;
      //for (let i=0;i<this.groups.length;i++) {
      //  let msgGroup = this.groups[i];
      //  if (msgGroup.msg_group_id == group.msg_group_id) {
      //    return mgStatic.MsgGroupMembers.length;
      //  }
      //}
      //return 0;
    },
    isText: function(msg) {
      //return msg && msg.length > 0;
      // regex to check if msg has img src tag
      if (msg.match(/<img src=/)) return false;
      return true;
    },
    resubscribeToMessages() {
      console.log("resubscribing to messages");
      this.$store.dispatch('resubscribeToMessages');
      this.$store.dispatch('getMsgGroups');

    },
  },
  mounted: function() {
    global.api.userAction('chats_read', null, 'webphone');
    console.log('getting msgGroups');
    this.$store.dispatch('getMsgGroups');
  }
});
</script>

<style>
html, body {
  margin:0px;
  height:100%;
}

.wrapperCard {
  height:205%;
}
.fillHeight {
  height:100%;
}
.opensidenav {
  width: 80% !important;
}

.hasUnreadMessages {
  font-weight: bold;
}

.hamburger {
  height: 45px;
  width: 45px; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 4; /* Stay on top, but under side nav */
  top: 40px; /* Stay at the top */
  left: 0;
  color: white;
  background-color: #444;
  overflow: hidden;
  font-size: 32px;
  padding-left: 8px;
  padding-right: 8px;
}

/* The side navigation menu */
.sidenav {
  height: calc(100vh - 40px); /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 5; /* Stay on top */
  top: 40px; /* Stay at the top */
  left: 0;
  background-color: #ccc; /* light gray */
  overflow-x: scroll; /* Disable horizontal scroll */
  overflow-y:scroll;
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}
</style>
